import { Dropdown } from "react-bootstrap";
import React,{useContext, useEffect, useState} from "react";

import Tooltip from '@mui/material/Tooltip';
import RestartAlt from '@mui/icons-material/RestartAlt';
import { productionService } from "../../services/productionService";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import { useLocation, useNavigate ,Link} from "react-router-dom";
import { useForm } from "react-hook-form";
import moment from "moment";
import LogicContext from "../../Context/LogicContext";
import { GetProductionAtomData, SetProductionAtomData } from "../../store/productionAtom";
import { isArray } from "lodash";

const columns = [
  {
    title: 'Ref',
    key: 'Ref_No',
    dataIndex: 'Ref_No',
  className: "text-primary",
  sorter: (a, b) => (a?.Ref_No ?? '') - (b?.Ref_No ?? '')
  },

  {
    title: 'Id',
    dataIndex: 'Production_Item_Id',
  sorter: (a, b) => (a?.Production_Item_Id ?? '').localeCompare(b?.Production_Item_Id ?? '')
  },
    
  {
    title: 'Product',
    dataIndex: 'Production_Item_Name',
  sorter: (a, b) => (a?.Production_Item_Name ?? '').localeCompare(b?.Production_Item_Name ?? '')
  },
    
  {
    title: "SKU",
    dataIndex: "Production_Item_Sku",
    sorter: (a, b) => (a?.Production_Item_Sku ?? '').localeCompare(b?.Production_Item_Sku ?? '')

  },

  {
    title: "Quantity",
    dataIndex: "Production_Quantity",
    sorter: (a, b) => (a?.Production_Quantity ?? '') - (b?.Production_Quantity ?? ''),
      render: (record)=> <span> {formatCustomNumber(record)} </span>

  },

  {
    title: "Production Date",
    dataIndex: "Production_Date",
    sorter: (a, b) => (a?.Production_Date ?? '').localeCompare(b?.Production_Date ?? ''),
    // render: (record)=> <span> {formatCustomNumber(record)} </span>

  },


  {
    title: "Created By",
    dataIndex: "Encoded_By_Name",
    sorter: (a, b) => (a?.Encoded_By_Name ?? '').localeCompare(b?.Encoded_By_Name ?? '')

  },



 
  
  {
    title: 'Status',
    dataIndex: 'Status_Name',
    sorter: (a, b) => (a?.Status_Name ?? '').localeCompare(b?.Status_Name ?? ''),
 
  },
  
  // {
  //   title: 'Date',
  //   dataIndex: 'Created_Date_String',
  //   sorter: (a, b) => (a?.Created_Date_String ?? '').localeCompare(b?.Created_Date_String ?? ''),
  //   render: (record) => <span>
  //   {record}
  // </span>,
  // },
];



function ProductionPage() {

  const { register, setValue, getValues,  handleSubmit, reset, formState: { errors }} = useForm();

    const [productionList, setProductionList] = useState([]);
    const setProductionAtomData = SetProductionAtomData();
    const getProductionAtomData = GetProductionAtomData();
     const navigate = useNavigate();
    const { pathname } = useLocation();
    var url = pathname.split("/");
    const currModuleId = url[1];
    const currModuleName = url[2];
    const currUserMenu = url[3];
      const [itemSelected, setItemSelected] = useState([]);
        const logicContext = useContext(LogicContext);
      
  
    useEffect(()=> {
      if(getProductionAtomData.production_info?.length){
        setProductionList(getProductionAtomData.production_info);
      }else{
        loadDataFromServer();
      }

  },[getProductionAtomData.production_info]);
  


    useEffect(()=> {
        if (sessionStorage.getItem('reloadPage') === 'true') {
          sessionStorage.removeItem('reloadPage');
          loadDataFromServer();
        }
    
      // eslint-disable-next-line react-hooks/exhaustive-deps
      },[]);


  const loadDataFromServer = ()=>{
    productionService.getProductionList().then((res)=> {
      if( isArray(res?.data?.production_info) && res?.data?.production_info?.length){
        setProductionList(res.data?.production_info);
        setProductionAtomData(res.data);
      }
     }).catch((err)=> {
      logicContext.showToast("data not loaded!", "");
     });
  }

  function selectedTableItems(itemList) {
    setItemSelected(itemList);
  }


  function handleRowClick(data) {
    const id = data["Ref_No"];
    navigate(
      `/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`
    );
  }


  const searchByDate = async (event) => {
      const formData = getValues();
      const response = await productionService.productionListByDate(formData);
      if (response?.data?.length) {
        setProductionList(response?.data);
      } else {
        logicContext.showToast("No result found", "");
        setProductionList([]);
      }
    };
  
  
  
    function customFilter(filter){
        // if(filter === 3 ){
        //   setList(itemList)
        // }else if(filter === 1){
        //   let newList = itemList?.filter(item =>  item.Item_Variety_Id === filter);
        //   setList(newList);
        // }else if(filter === 2){
        //   let newList = itemList?.filter(item =>  item.Item_Variety_Id === filter);
        //   setList(newList);
        // }
    }


    return ( 
        <>
           <section className=" py-4 px-2    md:flex justify-between ">
       
       <div className="flex">
       {/* <div className=" mt-1  rounded bg-filterColor pr-4 -ml-2 ">
            <Dropdown>
                <Dropdown.Toggle
                  style={{
                    backgroundColor: "#E5E5E5",
                    border: "none",
                    color: "#45444B",
                    fontSize: "12px",
                    height: "35px",
                  }}
                  id="dropdown-basic"
                >
                  FILTER BY
                </Dropdown.Toggle>
  
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => customFilter(3)}>
                    All
                  </Dropdown.Item>
  
                  <Dropdown.Item onClick={() => customFilter(1)}>
                    Single Items
                  </Dropdown.Item>
  
                  <Dropdown.Item onClick={() => customFilter(2)}>
                    Composite Items
                  </Dropdown.Item>
  
                </Dropdown.Menu>
              </Dropdown>
            </div> */}

            <Tooltip title="Reload">
            <RestartAlt className="cursor ml-2 mt-1" onClick={()=> loadDataFromServer()} color="primary" fontSize="large" />
          </Tooltip>
       </div>


               {/* date search */}
               <div class="flex flex-row items-end space-x-2">
                 <div>
                   <span className="ml-1 text-sm ">From Date:</span>
                   <input
                     defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
                     {...register("from_date")}
                     className=" bg-white ring-1 ring-gray-200  w-full pl-3  rounded max-h-full bottom-0 outline-none border-transparent focus:border-transparent focus:ring-0"
                     type="date"
                   />
                 </div>
       
                 <div>
                   <span className="ml-1 text-sm ">To Date:</span>
                   <input
                     {...register("to_date")}
                     defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
                     className=" bg-white ring-1 ring-gray-200  w-full pl-3  rounded max-h-full bottom-0 outline-none border-transparent focus:border-transparent focus:ring-0"
                     type="date"
                   />
                 </div>
                 <div>
                   <button
                     onClick={() => searchByDate()}
                     type="button"
                     className="text-sm text-white px-3 bg-blue-500 rounded py-2.5"
                   >
                     Search
                   </button>
                 </div>
               </div>
               {/* date search end */}

            
            <div className="flex  ">
              <div className="flex ">
                <button
                  style={{ color: "#476EF8" }}
                  className="  rounded  text-xs py-[1.8vh] font-[Poppins]   px-4"
                >
                  EXPORT
                </button>
              
              </div>
              <Tooltip title="Create new item">
              <Link to={`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`} >
              <button
                style={{ backgroundColor: "#476EF8" }}
                className="  rounded text-white text-sm font-[Poppins] mt-1 py-[1.8vh]  px-3"
              >
                Add New
              </button>
              </Link>
              </Tooltip>
           
            </div>
          </section>
  

  
          <section>
          <GeneralCustomTable
                            tableHeadList={columns} 
                            tableDataList={productionList}
                          allowCheckBox={true} // show checkBox for each row
                          setSelectedRows={selectedTableItems}
                          rowKey={(record) => record.Sales_Order_Ref_No} // custom key
                          handleRowClick={handleRowClick} />
          </section>
        </>
     );
}

export default ProductionPage;